module.exports = {"title":"Pillow fight!","date":"2017-05-14T20:30:00+05:30","path":"/2017-05-14-varanasi/","author":"HARRISON","body":"<p><img src=\"./snippet.jpg\" alt=\"Image\">\n<img src=\"./IMG_3754.jpg\" alt=\"Image\">\n<img src=\"./IMG_3759.jpg\" alt=\"Image\">\n<img src=\"./IMG_3761.jpg\" alt=\"Image\"></p>\n<h3>Views from the apartment building</h3>\n<p><img src=\"./IMG_2662.jpg\" alt=\"Image\">\n<img src=\"./IMG_3745.jpg\" alt=\"Image\"></p>\n"}


//////////////////
// WEBPACK FOOTER
// ./2017-05-14-photos/index.md
// module id = 1069
// module chunks = 0